export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10609.2b762f66.jpg";